import { createAction, props } from '@ngrx/store';
import { CalendarDay } from '@fc-shared/ui/shcedule-calendar/types';

export const setClickedDay = createAction(
  '[Schedule Calendar] Set Clicked Day',
  props<{ date: CalendarDay }>(),
);
export const clearCurrentDay = createAction(
  '[Schedule Calendar] Clear Clicked Day',
);
